/** @module Classes */ /** typedoc */

import { ModelStateError } from './ModelStateError'

export class ResponseError {
    httpCode: number;
    code: string;
    message: string;
    errors: ModelStateError[];

    /**
     *
     * @param httpResponseError - httpResponse
     * @returns {ResponseError}
     */
    static fromMonolith(httpResponseError: any = {}): ResponseError {
        let data = httpResponseError.data || {};
        let newResponseError = new ResponseError();

        newResponseError.httpCode = httpResponseError['status'];
        newResponseError.code = data['MgCode'];
        newResponseError.message = data['MgReason'];
        newResponseError.errors = (data['MgModelState'] || []).map((error) => {
            return ModelStateError.fromMonolith(error);
        });

        if (ResponseError.hasModelStateErrors(newResponseError.errors)) {
            let error = newResponseError.errors[0];
            newResponseError.code = error.code;
            newResponseError.message = error.message;
        }

        return newResponseError;
    }

    static hasModelStateErrors(errors: ModelStateError[]): boolean {
        return errors && errors.length > 0;
    };
}
